module.exports = __webpack_public_path__ + "img/a11y-stability-1_cn.f91dbb4.jpg";